/** Primary navigation, shared by the desktop header and the mobile index. */
export interface NavLink {
  name: string
  href: string
}

/** Desktop header nav (brief: About, Now, Projects, Reflections, CV, Contact). */
export const headerNav: NavLink[] = [
  { name: 'About', href: '/about' },
  { name: 'Now', href: '/now' },
  { name: 'Projects', href: '/projects' },
  { name: 'Reflections', href: '/writing' },
  { name: 'CV', href: '/cv' },
  { name: 'Contact', href: '/contact' },
]

/** Mobile index, numbered 01-07 and including Uses. */
export const mobileNav: NavLink[] = [
  { name: 'About', href: '/about' },
  { name: 'Now', href: '/now' },
  { name: 'Projects', href: '/projects' },
  { name: 'Reflections', href: '/writing' },
  { name: 'CV', href: '/cv' },
  { name: 'Uses', href: '/uses' },
  { name: 'Contact', href: '/contact' },
]

/** Two-digit index label for the mobile nav. */
export function navIndex(position: number): string {
  return String(position + 1).padStart(2, '0')
}
